<template>
  <div class="pt-md-3 pt-2">
    <div v-if="currentSection.support">
    <div class="support-link col-12 p-md-0" v-if= "currentSection.ehOrder === 1">
      <a
          target="_blank"
          :href="currentSection.support.url"
      >{{ currentSection.support.name }}</a>
    </div>
    </div>
    <div class="row">
      <div class="col-12 p-md-0">
        <div class="section-title">{{ currentSection.name }}</div>
        <hr class="hr-container"/>
        <div class="section-desc">{{ currentSection.description }}</div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-8">
        <div class="row mt-3">
          <div
              class="col-md-6 pt-3 p-md-0 pr-md-3 pb-md-3"
              v-for="child in cardsBySectionId(currentSection.id)"
              :key="child.id"
          >
            <div class="row">
              <div class="col-12">
                <div
                    class="card"
                    style="border: 1px solid #000 !important; height: 230px"
                >
                  <div class="card-body">
                    <div
                        class="
                        card-title
                        custom-card-title-container custom-card-title
                      "
                    >
                      {{ child.name }}
                    </div>
                    <div
                        class="card-text info-container"
                    ><div class="info-text-container" v-html="child.description" data-toggle="tooltip" data-placement="right" :title="cleanseHTML(child.description)">

                    </div>
                    </div>
                    <get-started class="pt-4" :cardId="child.id"></get-started>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4 p-md-0 pt-4 pl-4 pt-md-2">
        <div class="row">
          <div
              class="offset-md-2 col-md-10 p-md-0"
              v-for="child in currentSubSections"
              :key="child.id"
          >
            <div>
              <div class="custom-card-title">{{ child.name }}</div>
              <ul class="child-list">
                <li
                    class="pt-1"
                    v-for="resource in child.resources"
                    :key="resource.id"
                >
                  <a target="_blank"
                     class="side-section-lnk"
                     @click="trackSideSectionLink(child.name, resource)"
                     :href="resource.value"
                  >{{ resource.title }}</a
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GetStarted from "@/components/homepage/GetStarted";
import CardHelperMixin from "@/components/homepage/mixins/CardHelperMixin";
import MixpanelMixin from "@/mixins/MixpanelMixin";
import Constants from "@/store/constants";
import Vue from "vue";

export default {
  mixins: [CardHelperMixin, MixpanelMixin],
  methods: {
    trackSideSectionLink(sectionName, resource) {
      this.trackFeatureSelected(sectionName, resource.title, resource.value);
    },
    initializeTooltip() {
      /* eslint-disable no-undef */
      Vue.nextTick(function() {
        if (!window.matchMedia || (window.matchMedia("(min-width: 991px)").matches)) {
          $('[data-toggle="tooltip"]').tooltip({trigger:"hover"});
        }

      });
    },
    cleanseHTML: function(html) {
      let tmp = document.createElement("DIV");
      tmp.innerHTML = html;
      return tmp.textContent || tmp.innerText || "";
    },
  },
  mounted() {
    if (this.currentSubSections){
      this.initializeTooltip()
    }
  },
  data() {
    return {
      Constants
    }
  },
  components: {
    GetStarted,
  },
};
</script>
<style scoped>
</style>

<style>
.card-body {
  padding: 0.75rem !important;
  width: 100%;
}

.custom-card-title {
  font-size: 16px;
  font-weight: 700;
  font-family: artifaktElementExtraBold;
}

.custom-card-title-container {
  height: 50px;
}

.child-list {
  list-style-type: none;
  padding-inline-start: 0;
}

.side-section-lnk {
  text-decoration: underline;
  color: black !important;
  font-size: 14px;
  font-family: artifaktElementRegular !important;
  display: inline-flex;
}

.side-section-lnk:hover {
  color: black !important;
  text-decoration: underline;
}

.hr-container {
  border-top: 6px solid #000 !important;
}

.section-desc {
  font-size: 14px;
  font-family: artifaktElementRegular !important;
}

.support-link {
  text-align: right;
  font-size: 18px;
}

.info-container {
  max-height: 75px;
  min-height: 75px;
  margin-bottom: 10px;
  overflow: hidden;
}

.card-text {
  font-family: artifaktElementRegular !important;
  font-size: 14px !important;
}

.info-text-container {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>